import { karateR0Fetch } from "./karateR0ApiClient.js";

export async function formationListTracks() {
  return karateR0Fetch("/formation/tracks");
}

export async function formationGetProgress() {
  return karateR0Fetch("/formation/progress");
}

export async function formationGetContinue() {
  return karateR0Fetch("/formation/continue");
}

export async function formationGetTrackProgress(trackId) {
  return karateR0Fetch(`/formation/progress/${encodeURIComponent(trackId)}`);
}

export async function formationCompleteStep(trackId, stepId) {
  return karateR0Fetch(
    `/formation/progress/${encodeURIComponent(trackId)}/steps/${encodeURIComponent(stepId)}/complete`,
    { method: "POST" },
  );
}

export async function formationUpdateProgress(trackId, body) {
  return karateR0Fetch(`/formation/progress/${encodeURIComponent(trackId)}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export async function formationMarkIntroViewed(trackId) {
  return formationUpdateProgress(trackId, { introViewed: true });
}

export async function formationGetDiscovery() {
  return karateR0Fetch("/formation/discovery");
}

export async function formationUpdateDiscovery(body) {
  return karateR0Fetch("/formation/discovery", {
    method: "PUT",
    body: JSON.stringify(body),
  });
}
